import React from 'react';

import InfoIcon from '@mui/icons-material/Info';
import { Button, Stack, Tooltip } from '@mui/material';

import UnsavedChangesInfoIcon from '~/components/Common/Elements/UnsavedChangesInfoIcon';

type VoucherFormNavigationProps = {
  isSubmitting: boolean;
  hasUnsavedChanges: boolean;
  isEdit: boolean;
  showAdvanceDescription: boolean;
  onBack: () => void;
  onSubmit: () => void;
  onToggleAdvancedDescription: () => void;
  onOpenClone?: () => void;
};

export default function VoucherFormNavigation({
  isSubmitting,
  hasUnsavedChanges,
  isEdit,
  showAdvanceDescription,
  onBack,
  onSubmit,
  onToggleAdvancedDescription,
  onOpenClone,
}: VoucherFormNavigationProps) {
  return (
    <Stack direction="row" spacing={2}>
      <Button variant="text" onClick={onBack} disabled={isSubmitting}>
        Back to list
      </Button>
      <Button variant="contained" color="primary" onClick={onSubmit} disabled={isSubmitting}>
        {isSubmitting ? (isEdit ? 'Saving...' : 'Creating...') : isEdit ? 'Save' : 'Create'}
      </Button>
      <UnsavedChangesInfoIcon hasUnsavedChanges={hasUnsavedChanges} />
      {isEdit && onOpenClone && (
        <Button variant="text" onClick={onOpenClone} disabled={isSubmitting}>
          Clone
        </Button>
      )}
      <Tooltip title={showAdvanceDescription ? 'Hide Advanced Description' : 'Show Advanced Description'}>
        <InfoIcon onClick={onToggleAdvancedDescription} />
      </Tooltip>
    </Stack>
  );
}
